module.exports = __webpack_public_path__ + "img/llave1.00163117.png";